import { PopupWindow } from "./PopupWindow";

/**
 * Can be used as an alternative for `confirm('confirmMessage');`
 */
export class ConfirmWindow extends PopupWindow<boolean>
{
	constructor(message: string, ok: string, cancel: string)
	{
		super("", message, false, ok, cancel);
		this.okValue = true;
		this.cancelValue = false;
	}

	public static open(message: string, ok: string = "Yes", cancel: string = "No")
	{
		return new ConfirmWindow(message, ok, cancel).open();
	}
}